<template>

    <v-container>
      <v-row>
        <v-file-input
          v-model="files"
          class="input"
          chips
          :placeholder="placeHolder"
          :rules="rules"
          accept="image/png, image/jpeg, image/bmp"
          prepend-icon="mdi-camera"
        ></v-file-input>
        <p class="text">عکس مورد نظر خود را اپلود کنید</p>
      </v-row>
      <v-btn v-if="isSingle" :disabled="check" @click="send()">فرستادن</v-btn>
    </v-container>

</template>

<script>
  import { toBase64 } from  '../../../plugins/toBase64'
  import { setSliders } from  '../../../api/mainpage/topSection'
    export default {
        name: 'formInput',
      props :{
          isSingle: Boolean,
          placeHolder: String,
      },
      data: () => ({
        files:[],
        check:true,
        rules: [
          value => !value  || 'عکس مورد نظر خود را اپلود کنید.',
        ],
      }),
      methods:{
          send(){
            toBase64(this.files).then((result)=>
              {

                setSliders(
                {
                  imgPath: result
                }
              )}
            )
          },


        // deletLastImage(){
        //
        // }
        //   toBase64 (file: File): Promise<string> {
        //   return new Promise<string>((resolve, reject) => {
        //     const fileReader = new FileReader();
        //     fileReader.readAsDataURL(file);
        //     fileReader.onload = () => resolve(fileReader.result as string || '');
        //     fileReader.onerror = err => reject(err);
        //   });
        // }
      },
      watch:{
          files(){
              this.check = this.files === undefined;
              if(this.files!==undefined) {
                this.check = this.files.type !== 'image/png' && this.files.type !== 'image/jpeg' && this.files.type !== 'image/bmp'
              }
          }
      }
    }

</script>

<style scoped>
  .input{
    direction: ltr;
  }
  .row{
    justify-content: center;
    align-items: flex-end;
    flex-direction: row-reverse;
  }
  .text{
    font-family: anjoman;
    font-size: 1.25rem;
  }
  .v-input{
    margin-right: 100px;
  }


</style>
